import { ConsumableOverviewThemeSizeConfig } from './types';

const small: ConsumableOverviewThemeSizeConfig = {
  consumableOverview: {},
};

export default small;
